import {
  SHOW_WARN_POPUP,
  HIDE_WARN_POPUP,
  SET_WARN_POPUP_TEXT,
  SET_WARN_POPUP_USERID,
} from './types';

const initialState = {
  show: false,
  userId: '',
  text: '',
};

const warnPopupReducer = (state = initialState, action) => {
  switch (action.type) {
  case SHOW_WARN_POPUP:
    return {
      ...state,
      show: true,
      userId: action.payload.userId,
    };
  case HIDE_WARN_POPUP:
    return {
      ...state,
      show: false,
      userId: '',
      text: '',
    };
  case SET_WARN_POPUP_TEXT:
    return {
      ...state,
      text: action.payload,
    };
  case SET_WARN_POPUP_USERID:
    return {
      ...state,
      userId: action.payload,
    };
  default:
    return state;
  }
};

export default warnPopupReducer;
